import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


const pharmacyApiUrl = typeof window !== 'undefined' ? window.serverData.data.pharmacyApiUrl : ''; // window is undefined during pre-render

//Not using this all methods, since we moved centralized proxy system. Please refer proxyApi.js
export const getProxiesInfo = (token) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/PharmacyProxy/ProxiesInfo`);
    const start = new Date();
    //debugger;
    return fetch2(url, token).then(response => {
        //debugger;
        logAPI("MBHWeb.Api.Rx.Proxy.GetProxyInfo", start, url);
        return response;
    }).catch((err) => {
        //debugger;
        console.error(err);
        logAPI("MBHWeb.Api.Rx.Proxy.GetProxyInfo.Failure", start, url, err);
        return { WhoCanManageYou: [], WhoYouCanManage: [] }; // give back something besides null, we cannot stop the site because pharmacy ever goes down, this particular call is huge
    });
};

export const requestAccess = (token, firstName, lastName, dateOfBirth, zipCode, rxNumber, phone, relationship, email) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/PharmacyProxy/RequestProxyAccess`);
    const start = new Date();
    const data = { firstName, lastName, dateOfBirth, zipCode, rxNumber, phone, relationship, email };
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Rx.Proxy.RequestProxyAccess", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Proxy.RequestProxyAccess.Failure", start, url, err); return Promise.reject(err); });
};

export const resendRequest = (token, id) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/PharmacyProxy/ResendProxyAccessRequest?proxyRequestID=${id}`);
    const start = new Date();
    return fetch2(url, token, null, 'post').then(response => {
        logAPI("MBHWeb.Api.Rx.Proxy.ResendProxyAccessRequest", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Proxy.ResendProxyAccessRequest.Failure", start, url, err); return Promise.reject(err); });
};

export const removeAccess = (token, id) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/PharmacyProxy/CancelProxyRequest?proxyRequestID=${id}`);
    const start = new Date();
    return fetch2(url, token, null, 'put').then(response => {
        logAPI("MBHWeb.Api.Rx.Proxy.CancelProxyRequest", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Proxy.CancelProxyRequest.Failure", start, url, err); return Promise.reject(err); });
};

export const approveRequest = (token, id) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/PharmacyProxy/ApproveProxyRequest?proxyRequestId=${id}`);
    const start = new Date();
    return fetch2(url, token, null, 'put').then(response => {
        logAPI("MBHWeb.Api.Rx.Proxy.ApproveProxyRequest", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Proxy.ApproveProxyRequest.Failure", start, url, err); return Promise.reject(err); });
};

export const declineRequest = (token, requestId) => {
    const url = encodeURI(`${pharmacyApiUrl}api/PharmacyProxy/DeclineProxyRequest?proxyRequestId=${requestId}&isUnKnown=false`);
    const start = new Date();
    return fetch2(url, token, null, 'put').then(response => {
        logAPI("MBHWeb.Api.Rx.Proxy.DeclineProxyRequest", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Proxy.DeclineProxyRequest.Failure", start, url, err); return Promise.reject(err); });
};

export const getAccessList = (token) => {
    return getProxiesInfo(token).then(response => {
        const list = response.WhoYouCanManage
            .filter(userAccess => userAccess.Status === 'Approved')
            .map((userAccess, index) => {
                return {
                    firstName: userAccess.FirstName,
                    lastName: userAccess.LastName,
                    displayName: userAccess.FirstName + ' ' + userAccess.LastName,
                    pharmacyPatientId: userAccess.PatientId,
                    index: JSON.stringify(index + 1)
                };
            });
        return list;
    });
};


export const grantAccess = (token, accessorName, email) => {
    //const url = encodeURI(`${pharmacyApiUrl}Api/PharmacyProxy/GrantProxyAccess`);
    //const start = new Date();
    //const data = { accessorName, email };
    //return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
    //    logAPI("MBHWeb.Api.Rx.Proxy.GrantProxyAccess", start, url);
    //    return response;
    //}).catch(err => { logAPI("MBHWeb.Api.Rx.Proxy.GrantProxyAccess.Failure", start, url, err); return Promise.reject(err); });

    // until the api call of GrantProxyAccess is available
    return {
        "Status": "Pending"
    };
};

export const healthRecordGrantAccess = (token, accessorName, email) => {
    //const url = encodeURI(`${pharmacyApiUrl}Api/PharmacyProxy/GrantProxyAccess`);
    //const start = new Date();
    //const data = { accessorName, email };
    //return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
    //    logAPI("MBHWeb.Api.Rx.Proxy.GrantProxyAccess", start, url);
    //    return response;
    //}).catch(err => { logAPI("MBHWeb.Api.Rx.Proxy.GrantProxyAccess.Failure", start, url, err); return Promise.reject(err); });

    // until the api call of GrantProxyAccess is available
    return {
        "Status": "Pending"
    };
};


export const requestHealthRecordAccess = (token, firstName, lastName, dateOfBirth, zipCode, rxNumber, phone, relationship, email) => {
    //const url = encodeURI(`${pharmacyApiUrl}Api/PharmacyProxy/RequestProxyAccess`);
    //const start = new Date();
    //const data = { firstName, lastName, dateOfBirth, zipCode, rxNumber, phone, relationship, email };
    //return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
    //    logAPI("MBHWeb.Api.Rx.Proxy.RequestProxyAccess", start, url);
    //    return response;
    //}).catch(err => { logAPI("MBHWeb.Api.Rx.Proxy.RequestProxyAccess.Failure", start, url, err); return Promise.reject(err); });

    //error case
    //return Promise.reject({ error: {"Status" : 404} });

    //success case
    return {
        "Status": "Pending"
    };

};
